import moment from 'moment';
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';

export function exportReportFincenterColumns({ t, lang, onDownloadZip }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      filterable: false,
      style: { textAlign: 'center' },

    },
    {
      Header: t('ID'),
      accessor: 'id',
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('contingentPage_columnExportCreationDate'),
      accessor: 'createdAt',
      Cell: row =>
        row.original.createdAt
          ? moment(row.original.createdAt).format('DD.MM.YYYY / HH:mm')
          : '',
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('contingentPage_columnExportUpdatedAtDate'),
      accessor: 'updatedAt',
      Cell: row =>
        row.original.updatedAt
          ? moment(row.original.updatedAt).format('DD.MM.YYYY / HH:mm')
          : '',
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('contingentPage_columnExportStatus'),
      accessor: 'status',
      filterable: false,
      style: { textAlign: 'center' },
      Cell: () => (
        <span>{t('contingentPage_columnExportStatusSent')}</span>
      )
    },
    {
      Header: t('kezekBulletin_columnServiceProviderLocation'),
      accessor: 'serviceProviderLocation',
      Cell: ({ original: { serviceProviderLocation } }) => serviceProviderLocation[`${lang}_name`],
      filterable: false
    },
    {
      Header: t('contingentPage_actions'),
      style: { textAlign: 'center', alignSelf: 'center' },
      filterable: false,
      Cell: ({ original }) => (
        <div style={{ margin: '-5px 0' }}>
          <Tooltip placement="top" title={t('contingentPage_download')}>
            <IconButton
              color="primary"
              size="small"
              onClick={e => {
                e.stopPropagation();
                onDownloadZip(original.id,original.fileName);
              }}
            >
              <GetAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      )
    }
  ];
}
